<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#00a972" right :timeout="timeout">
      {{msg}}
      <v-btn text @click="showsnackbar = false">
        <v-icon style="color:white;">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-layout pt-6 wrap justify-center>
      <v-flex xs12 sm12 md6>
        <v-layout wrap px-2>
          <v-flex xs12 sm12 md12 text-left>
            <span style="font-size:22px;font-weight:600;">Blog</span>
          </v-flex>
        </v-layout>
        <v-layout wrap px-2>
          <v-flex v-if="blogData.type=='Normal Blog'">
            <v-img max-height="400px" :src="baseURL+'/u/'+blogData.image" contain>
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-flex>
          <v-flex v-if="blogData.type=='Video Blog'">
            <video width="100%" height="365" controls>
              <source :src="baseURL+'/u/'+blogData.video" type="video/mp4" />
            </video>
          </v-flex>
          <v-flex v-if="blogData.type=='Document Blog'">
            <v-img max-height="400px" :src="baseURL+'/u/'+blogData.thumbnail" contain>
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex xs12 sm12 md12 px-4 pt-2>
            <span style="font-size:20px;font-weight:600;">{{blogData.title}}</span>
          </v-flex>
          <v-flex xs12 sm12 md12 px-4 pt-2 text-justify>
            <span style="font-size:18px;font-weight:400">{{blogData.shortDescription}}</span>
          </v-flex>
        </v-layout>
        <v-layout wrap px-4 pt-2>
          <v-flex text-left>
            <span style="font-size:16px;font-weight:400;color:#1fb07c">{{blogData.author}}</span>
          </v-flex>
          <v-flex text-left>
            <span style="font-size:16px;font-weight:400;color:#1fb07c">{{blogData.createddate}}</span>
          </v-flex>
          <v-flex text-left>
            <span style="font-size:16px;color:#1fb07c" class="px-1">
              <v-icon
                :color="blogData.isUpVoted ? '#1fb07c' : '#888888' "
                @click="upvote"
              >mdi-thumb-up-outline</v-icon>
            </span>
            <span style="font-size:16px;color:#1fb07c" class="pr-2">
              <v-icon
                :color="blogData.isDownVoted ? '#1fb07c' : '#888888' "
                @click="downvote"
              >mdi-thumb-down-outline</v-icon>
            </span>
            <span style="font-size:16px;color:#1fb07c">
              <v-icon
                :color="blogData.isBookMarked ? '#1fb07c' : '#888888' "
                @click="bookmark"
              >mdi-bookmark-outline</v-icon>
            </span>
          </v-flex>
        </v-layout>
        <v-layout wrap px-4 pt-2>
          <v-flex text-justify>
            <span style="font-size:16px;font-weight:400" v-html="blogData.body"></span>
          </v-flex>
        </v-layout>
        <v-layout v-if="blogData.type=='Document Blog'" wrap px-4 pt-2>
          <v-flex text-justify>
            <span style="font-size:16px;font-weight:500;">Download Document :&nbsp;</span>
            <a :href="baseURL+'/u/'+blogData.document" download target="_blank">
              <span style="font-size:16px;font-weight:500;color:#1fb07c">{{blogData.document}}</span>
            </a>
          </v-flex>
        </v-layout>
        <v-layout pt-2 wrap justify-center px-4>
          <v-flex>
            <v-divider></v-divider>
          </v-flex>
        </v-layout>
        <v-layout wrap py-1 px-4>
          <v-flex xs2 sm2 md2>
            <span style="font-size:12px;font-Weight:500;">Tags:&nbsp;</span>
          </v-flex>
          <v-flex xs2 sm2 md2 text-left v-for="(item, i) in blogData.tag" :key="i">
            <router-link :to="'/Blog/Filter/tag/'+item">
              <v-chip class="mx-1" x-small style="cursor: pointer;">{{item}}</v-chip>
            </router-link>
          </v-flex>
        </v-layout>

        <v-layout wrap py-1 px-4>
          <v-flex xs2 sm2 md2>
            <span style="font-size:12px;font-Weight:500;">Categories:&nbsp;</span>
          </v-flex>
          <v-flex xs2 sm2 md2 text-left v-for="(item, i) in cat" :key="i">
            <router-link :to="'/Blog/Filter/category/'+item">
              <v-chip class="mx-1" x-small style="cursor: pointer;">{{item}}</v-chip>
            </router-link>
          </v-flex>
        </v-layout>
        <v-layout pt-2 wrap justify-center px-4>
          <v-flex>
            <v-divider></v-divider>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";

export default {
  props: ["blogData"],
  data() {
    return {
      appLoading: false,
      showsnackbar: false,
      timeout: 5000,
      categories: [],
      cat: [],
      msg: null,
      ServerError: false
    };
  },
  beforeMount() {
    var dt = new Date(this.blogData.createddate);
    var day = dt.getDate();
    var year = dt.getFullYear();
    var hours = dt.getHours();
    var minutes = dt.getMinutes();
    dt = dt.toString();
    var ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime =
      day +
      " " +
      dt.slice(4, 7) +
      " " +
      year +
      " " +
      hours +
      ":" +
      minutes +
      " " +
      ampm;

    this.blogData.createddate = strTime;
    this.getCategory();
  },
  methods: {
    getCategory() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/project/category/getlist"
      })
        .then(response => {
          this.appLoading = false;
          this.categories = response.data.data;
          for (var i = 0; i < this.blogData.category.length; i++) {
            for (var j = 0; j < this.categories.length; j++) {
              if (this.blogData.category[i] == this.categories[j]._id) {
                this.blogData.category[i] = this.categories[j].name;
              }
            }
          }
          this.cat = this.blogData.category;
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    },
    bookmark() {
      if (localStorage.getItem("token")) {
        this.appLoading = true;
        axios({
          method: "POST",
          url: "/blog/bookmark",
          headers: {
            "x-auth-token": localStorage.getItem("token")
          },
          data: {
            id: this.blogData._id,
            status: !this.blogData.isBookMarked
          }
        })
          .then(response => {
            this.appLoading = false;
            this.blogData.isBookMarked = !this.blogData.isBookMarked;
            this.msg = response.data.msg;
            this.showsnackbar = true;
          })
          .catch(err => {
            this.msg = err;
            this.ServerError = true;
          });
      } else {
        this.msg = "Please Login to Bookmark";
        this.showsnackbar = true;
      }
    },

    upvote() {
      if (localStorage.getItem("token")) {
        this.appLoading = true;
        axios({
          method: "POST",
          url: "/blog/upvote",
          headers: {
            "x-auth-token": localStorage.getItem("token")
          },
          data: {
            id: this.blogData._id,
            status: !this.blogData.isUpVoted
          }
        })
          .then(response => {
            this.appLoading = false;
            this.blogData.isUpVoted = !this.blogData.isUpVoted;
            if (this.blogData.isUpVoted) {
              this.blogData.isDownVoted = false;
            }
            this.msg = response.data.msg;
            this.showsnackbar = true;
          })
          .catch(err => {
            this.msg = err;
            this.ServerError = true;
          });
      } else {
        this.msg = "Please Login to Vote";
        this.showsnackbar = true;
      }
    },
    downvote() {
      if (localStorage.getItem("token")) {
        this.appLoading = true;
        axios({
          method: "POST",
          url: "/blog/downvote",
          headers: {
            "x-auth-token": localStorage.getItem("token")
          },
          data: {
            id: this.blogData._id,
            status: !this.blogData.isDownVoted
          }
        })
          .then(response => {
            this.appLoading = false;
            this.blogData.isDownVoted = !this.blogData.isDownVoted;
            if (this.blogData.isDownVoted) {
              this.blogData.isUpVoted = false;
            }
            this.msg = response.data.msg;
            this.showsnackbar = true;
          })
          .catch(err => {
            this.msg = err;
            this.ServerError = true;
          });
      } else {
        this.msg = "Please Login to Vote";
        this.showsnackbar = true;
      }
    }
  }
};
</script>